import axios from "axios";
import api, { API } from "@/lib/api";

const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
export const isIOS = /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && typeof navigator !== "undefined" && navigator.maxTouchPoints > 1);
export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const permission = () => (("Notification" in window) ? Notification.permission : "unsupported");

const toBytes = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const registerSW = (path = "/sw.js") =>
  ("serviceWorker" in navigator) ? navigator.serviceWorker.register(path, { scope: "/" }).catch(() => null) : Promise.resolve(null);

async function getSubscription(create) {
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub && create) {
    const { data } = await axios.get(`${API}/push/public-key`);
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.public_key) });
  }
  return sub;
}

// Must be called from a click (iOS requirement).
export async function enablePush(guestToken) {
  if (!pushSupported()) throw new Error("unsupported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");
  const sub = await getSubscription(true);
  await saveSub(sub, guestToken);
  return sub;
}

const saveSub = (sub, guestToken) => guestToken
  ? axios.post(`${API}/public/push/${guestToken}`, sub.toJSON())
  : api.post("/push/subscribe", sub.toJSON());

// Re-link an existing subscription to the current user/guest (e.g. after another login on this device).
export async function syncPush(guestToken) {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  const sub = await getSubscription(false);
  if (!sub) return false;
  await saveSub(sub, guestToken).catch(() => {});
  return true;
}

export async function forgetPush() {
  if (!pushSupported()) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/");
    const sub = reg && await reg.pushManager.getSubscription();
    if (sub) await axios.post(`${API}/push/unsubscribe`, { endpoint: sub.endpoint, auth: sub.toJSON().keys?.auth || "" });
  } catch { /* ignore */ }
}

export function setBadge(n) {
  try {
    if (n > 0) navigator.setAppBadge?.(n);
    else navigator.clearAppBadge?.();
  } catch { /* unsupported */ }
}
